import React, { Component } from "react";
import { Popover, Form, Button, Icon, Table, Modal, Input, message } from "antd";
import { getPatientSourceList, addPatientSource, editPatientSource, deletePatientSource } from '@/request/api'
import { requestErrorLog } from '@/common/util'
import './components.scss'

const { confirm } = Modal;
const { TextArea} = Input;
class SettingDepartment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableList: [],
      pageNo: 1,
      pageSize: 10,
      rowCount: 0,
      className :'',
      textareaText :'',
      departmentColumns: [
        {
          title: "来源编码",
          dataIndex: "PATIENT_SOURCE_UID",
          key: "PATIENT_SOURCE_UID",
          width: 170,
        },
        {
          title: "来源名称",
          dataIndex: "PATIENT_SOURCE_NAME",
          key: "PATIENT_SOURCE_NAME",
          width: 170,
        },
        {
          title: "备注",
          dataIndex: "REMARKS",
          key: "REMARKS",
          width: 300,
          ellipsis :true,
          render: (text) => {
            return (
              <Popover
                overlayStyle={{ width: "300px" }}
                content={<span style={{ color: "#333" }}>{text}</span>}
                placement="topLeft"
              >
                <span>{text}</span>
              </Popover>
            );
          },
        },
      ],
    }
  }

  componentDidMount() {
    this.getTableList()
  }

  getTableList = () => {
    let params = {
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      NAME : this.state.className
    }
    getPatientSourceList(params).then(res => {
      if (res && res.Status === 1) {
        this.setState({
          tableList: res.Result.dataList,
          rowCount: res.Result.rowCount,
          rowData:null,
        })
      }else{
				requestErrorLog('', '系统设置-患者来源-获取患者来源列表报错', 0, true)
      }
    })
  }

  handlePatSourceAdd = () => {// 新增
    this.setState({
      isModalVisible: true,
      modalTitle: 'add',
    },()=>{
      this.props.form.resetFields();
      this.props.form.setFieldsValue({
        PATIENT_SOURCE_NAME : '',
        REMARKS : ''
      })
    })
  }

  handlePatSourceEdit = () => { // 修改
    const { rowData } = this.state
    this.props.form.resetFields();
    if (rowData && rowData.PATIENT_SOURCE_CODE) {
      this.setState({
        editModalVisible: true,
        modalTitle: 'edit',
      })
    } else {
      message.warning('请先选择要操作的数据');
    }
  }

  handlePatSourceDelete = () => { // 删除
    const { rowData } = this.state
    if (rowData) {
      confirm({
        title: '删除操作',
        content: '确认删除该患者来源吗？',
        onOk: () => {
          deletePatientSource(rowData).then(res=>{
            if(res && res.Status === 1){
              message.success('删除成功')
              this.getTableList()
            } else {
              requestErrorLog('', '系统设置-患者来源-删除患者来源报错', 0, true)
              message.error('删除失败')
            }
          })

        },
      });
    } else {
      message.warning('请先选择要操作的数据');
    }
  }

  handleOk = () => {
    const { isModalVisible, editModalVisible, rowData } = this.state
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (isModalVisible === true) {
          const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
          let params = {
            PATIENT_SOURCE_NAME : values.PATIENT_SOURCE_NAME,
            REMARKS : values.REMARKS,
          }
          addPatientSource(userInfo.HOSPITAL_CODE,params).then(res=>{
            console.log(res)
            if(res && res.Status === 1){
              if(res.Result === '2'){
                message.error('名称不能重复')
                return;
              }
              message.success('添加成功')
              this.getTableList()
            } else {
              requestErrorLog('', '系统设置-患者来源-添加患者来源报错', 0, true)
              message.error('添加失败')
            }
            this.setState({
              isModalVisible : false
            })
          })
        }
        if (editModalVisible === true) {
          let params = {
            PATIENT_SOURCE_UID : rowData.PATIENT_SOURCE_UID,
            PATIENT_SOURCE_CODE : rowData.PATIENT_SOURCE_CODE,
            PATIENT_SOURCE_NAME : values.PATIENT_SOURCE_NAME,
            REMARKS : values.REMARKS,
          }
          editPatientSource(params).then(res=>{
            if(res && res.Status === 1){
              if(res.Result === '2'){
                message.error('名称不能重复')
                return;
              }
              message.success('编辑成功')
              this.getTableList()
            } else {
              requestErrorLog('', '系统设置-患者来源-编辑患者来源报错', 0, true)
              message.error('编辑失败')
            }
            this.setState({
              editModalVisible :false,
            })
          })
        }
      }
    })
  }

  onClickRow = (record) => {
    return {
      onClick: () => {
        this.setState({
          rowData: record
        });
      },
    };
  }

  setRowClassName = (record) => {
    return record === this.state.rowData ? 'clickRowStyl' : '';
  }

  handleCancel = () => {
    this.setState({
      isModalVisible: false,
      editModalVisible: false
    })
  }

  classNameChange = e => {
    this.setState({
      className: e.target.value,
    })
  }

  handleCheckTypeList = () => {
    this.setState({
      pageNo: 1,
      pageSize: 10
    }, () => {
      this.getTableList()
    })
  }
  changeFocus = e => {
    if (e.keyCode === 13) {
      this.handleCheckTypeList();
    }
  }
  changePageFn = (pageNo) => {
    this.setState({
      pageNo
    }, () => {
      this.getTableList()
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { isModalVisible, editModalVisible, modalTitle, departmentColumns, tableList, rowData } = this.state;

    return (
      <div>
        <div className="btnStyle" style={{ marginBottom: "10px" }}>
          <Button onClick={this.handlePatSourceAdd}>
            <Icon type="plus-circle" />
            添加
          </Button>
          <Button onClick={this.handlePatSourceEdit}>
            <Icon type="minus-circle" />
            修改
          </Button>
          <Button onClick={this.handlePatSourceDelete}>
            <Icon type="close-circle" />
            删除
          </Button>
        </div>
        <Form layout="inline" className="searchBox">
          <Form.Item label="来源名称">
            <Input allowClear value={this.state.className} onChange={this.classNameChange} onKeyUp={this.changeFocus} />
          </Form.Item>
          <Button onClick={this.handleCheckTypeList}>查询</Button>
        </Form>
        <Table
          columns={departmentColumns}
          dataSource={tableList}
          rowKey={(record) => record.PATIENT_SOURCE_UID}
          bordered
          pagination={{
            total: this.state.rowCount,
            current: this.state.pageNo,
            onChange: this.changePageFn
          }}
          onRow={this.onClickRow}
          rowClassName={this.setRowClassName}
        />
        {isModalVisible || editModalVisible ?
          <Modal
            title={
              <div className="patient_title">
                <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
                <span>{modalTitle === "add" ? "添加来源" : "编辑来源"}</span>
              </div>
            }
            visible={isModalVisible || editModalVisible}
            maskClosable={false}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
          >
            <Form layout="inline" className="settingFormBox">
              <Form.Item label="来源名称" className="settingHospitalAddr">
                {getFieldDecorator('PATIENT_SOURCE_NAME', { initialValue: rowData && rowData.PATIENT_SOURCE_NAME ? rowData.PATIENT_SOURCE_NAME : '',rules: [{ required: true, message: '请输入来源名称' }] })(<Input allowClear={true} />)}
              </Form.Item>
              <Form.Item label="备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注" className="settingHospitalAddr">
                {getFieldDecorator('REMARKS', { initialValue: rowData && rowData.REMARKS ? rowData.REMARKS : ''})(<TextArea rows={5} />)}
              </Form.Item>
            </Form>
          </Modal> : null
        }

      </div>
    );
  }
}

export default (Form.create({})(SettingDepartment));
